module.exports = __webpack_public_path__ + "media/media/advantages/multi_platform_solution-eca867119022c4b78ae47636ed87f736.png";